import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";

export const useViewDistributorUsers = (id, enabled = true) => {
  return useQuery({
    queryKey: ['viewDistributorUsers', id],
    enabled: !!id && enabled, 
    queryFn: async ({ queryKey }) => {
      const distributerid = queryKey[1];   
      const res = await api.get(`/distributor/${distributerid}/users`);
      return res.data;
    },
  });
};